<template>
    <div>
        <ul class="nav-tabs" id="myTab" role="tablist">
            <li v-for="(tab, index) in tabs">
                <a :data-tab=index
                   href role="tab" aria-controls="home" aria-selected="true" class="nav-link"
                   @click.prevent="onglet = index"
                   :class="{ active: isActive(index) }">
                    {{ tab.titre_onglet }}
                </a>
            </li>
        </ul>
        <div class="mobile-select">
            <custom-select
                    valueField="index"
                    labelField="titre_onglet"
                    v-model="onglet"
                    :options="tabs"
            ></custom-select>
        </div>

        <div class="tab-content">

            <transition name="slide-fade" mode="out-in">

                <div v-for="(tab, index) in tabs"
                     class="tab-panel"
                     id="home" role="tabpanel" aria-labelledby="home-tab"
                     v-if="isActive(index)"
                     :key="index"
                >
                    <slot :name="tab.titre_slug"></slot>
                </div>

            </transition>

        </div>

    </div>
</template>

<script>
    import $ from 'jquery';
    import Scrolling from '../libs/Scrolling';
    import {findIndex} from 'lodash';

    export default {
        props: {
            tabs: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                onglet: 0,
            };
        },
        computed: {},
        methods: {
            isActive(index) {
                return this.onglet === index;
            },

        },
        watch: {
            onglet: function (newVal,oldVal) {
                this.onglet = Number(newVal)
            }
        },
        mounted() {
            if ($('body').hasClass('single-cruise')) {
                $('.tab-content').addClass('rte');
            }

            $('.link-to-cruise-tab').on('click', (event) => {
                event.preventDefault();
                Scrolling.scrollTo('.tab-infos', 'easeInOutQuint', 1000, 80);
                let found = findIndex(this.tabs, function (o) {
                    return o.titre_slug === 'extensions-et-options';
                })
                if (found !== -1){
                    this.onglet = found
                }

            });
        }

    };
</script>


// WEBPACK FOOTER //
// assets/js/components/Tabs.vue